import { clientAPI } from './api';

export interface Client {
  id: string;
  name: string;
  phone?: string;
  document?: string;
}

export const searchClients = async (query: string): Promise<Client[]> => {
  const response = await clientAPI.get('/clients/search', {
    params: { q: query }
  });
  return response.data;
};

export const createClient = async (data: {
  name: string;
  phone?: string;
  document?: string;
}) => {
  const response = await clientAPI.post('/clients', data);
  return response.data;
};

